var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8666 1.0107L21.3926 17.5107C21.4804 17.6627 21.5266 17.8352 21.5266 18.0107C21.5266 18.1862 21.4804 18.3587 21.3926 18.5107C21.3048 18.6627 21.1786 18.7889 21.0266 18.8767C20.8746 18.9645 20.7021 19.0107 20.5266 19.0107H1.47458C1.29905 19.0107 1.12661 18.9645 0.974593 18.8767C0.822577 18.7889 0.696343 18.6627 0.608578 18.5107C0.520812 18.3587 0.474608 18.1862 0.474609 18.0107C0.47461 17.8352 0.520817 17.6627 0.608584 17.5107L10.1346 1.0107C10.2224 0.858691 10.3486 0.732464 10.5006 0.644704C10.6526 0.556944 10.8251 0.510742 11.0006 0.510742C11.1761 0.510742 11.3485 0.556944 11.5006 0.644704C11.6526 0.732464 11.7788 0.858691 11.8666 1.0107ZM3.20658 17.0107H18.7946L11.0006 3.5107L3.20658 17.0107ZM10.0006 14.0107H12.0006V16.0107H10.0006V14.0107ZM10.0006 7.0107H12.0006V12.0107H10.0006V7.0107Z",
    fill: "#DEA01E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGold);
export default __webpack_public_path__ + "static/media/alert-gold.a905f583ae35b2cabd5b10867fd46554.svg";
export { ForwardRef as ReactComponent };